// src/components/Legal/Terms.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
  };

  const sectionStyle = {
    marginBottom: '30px',
  };

  const headingStyle = {
    color: '#2980B9',
    marginTop: '30px',
    marginBottom: '15px',
  };

  const linkStyle = {
    color: '#2980B9',
    textDecoration: 'underline',
  };

  return (
    <div style={containerStyle}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{ color: '#2980B9' }}>
          <span style={{ color: "#2980B9" }}>cis</span>
          <span style={{ color: "#CE93D8" }}>fuss</span> Terms of Service
        </h1>
        <p>Last Updated: 2 March 2025</p>
      </div>

      <div style={sectionStyle}>
        <p>
          Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the cisfuss website and services operated by cisfuss ("us", "we", or "our").
        </p>
        <p>
          Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.
        </p>
        <p>
          By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>1. Accounts</h2>
        <p>
          When you create an account with us, you must provide accurate, complete, and up-to-date information. You are responsible for safeguarding the password you use to access the Service and for any activities or actions under your password.
        </p>
        <p>
          You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>2. Use of Service</h2>
        <p>
          You agree to use the Service only for purposes that are legal, proper, and in accordance with these Terms and any applicable laws or regulations.
        </p>
        <p>
          You agree not to:
        </p>
        <ul>
          <li>Use the Service in any way that could disable, overburden, damage, or impair the Service</li>
          <li>Introduce any viruses, Trojan horses, worms, logic bombs, or other malicious or technologically harmful material</li>
          <li>Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Service, the server on which the Service is stored, or any server, computer, or database connected to the Service</li>
          <li>Use the Service for any commercial solicitation purposes without our express consent</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>3. Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are and will remain the exclusive property of cisfuss and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries.
        </p>
        <p>
          Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of cisfuss.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>4. User Content</h2>
        <p>
          Our Service allows you to save job listings and create a profile. You are responsible for the content you save and the activities on your account.
        </p>
        <p>
          By using our Service, you grant us the right to process and store the content you save according to our Privacy Policy.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>5. Third-Party Links</h2>
        <p>
          Our Service may contain links to third-party websites or services that are not owned or controlled by cisfuss.
        </p>
        <p>
          cisfuss has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that cisfuss shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.
        </p>
        <p>
          We strongly advise you to read the terms and conditions and privacy policies of any third-party websites or services that you visit.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>6. Termination</h2>
        <p>
          We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
        </p>
        <p>
          Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service or request account deletion.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>7. Limitation of Liability</h2>
        <p>
          In no event shall cisfuss, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
        </p>
        <ul>
          <li>Your access to or use of or inability to access or use the Service</li>
          <li>Any conduct or content of any third party on the Service</li>
          <li>Any content obtained from the Service</li>
          <li>Unauthorized access, use, or alteration of your transmissions or content</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>8. Disclaimer</h2>
        <p>
          Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance.
        </p>
        <p>
          cisfuss, its subsidiaries, affiliates, and its licensors do not warrant that:
        </p>
        <ul>
          <li>The Service will function uninterrupted, secure, or available at any particular time or location</li>
          <li>Any errors or defects will be corrected</li>
          <li>The Service is free of viruses or other harmful components</li>
          <li>The results of using the Service will meet your requirements</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>9. Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.
        </p>
        <p>
          Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>10. Changes to Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </p>
        <p>
          By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>11. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us by email at: <a href="mailto:contact@cisfuss.io" style={linkStyle}>contact@cisfuss.io</a>
        </p>
      </div>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Link to="/" style={linkStyle}>Return to Dashboard</Link>
        {' | '}
        <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
      </div>
    </div>
  );
};

export default Terms;